import { useEffect, useState } from 'react';
import classes from 'components/StoreLocations/StoreLocations.module.scss'
import StoreLocationTile from 'components/StoreLocations/StoreLocationTile/StoreLocationTile';
import Constants from 'config/constants';
import Button from '@material-ui/core/Button';
import { RadioButtonChecked, RadioButtonUnchecked } from '@material-ui/icons';
import { StoreChain } from 'utils/StoreChain';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';

export default function StoreLocations(props) {
	const [selectedStore, setSelectedStore] = useState(null);
	const [showAltChain, setShowAltChain] = useState(null);

	const buttonTheme = createMuiTheme({
		palette: {
			primary: {
				main: props.pickupWebsite === Constants.COOKIE_GOLF_GALAXY ? "#677406" : (props.pickupWebsite === Constants.COOKIE_PUBLIC_LANDS ? "#002A19" : "#BB5811")
			}
		}
	});

	useEffect(() => {
		setShowAltChain(StoreChain.isMultiChain(props.stores, props.pickupWebsite));
		// eslint-disable-next-line
	}, [props.stores]);

	const handleStoreSelection = (selection) => {
		setSelectedStore(selection);
	};

	const PickupLocation = (props) => {
		return (
			<div className={classes.StoreTile}>
				<div className={classes.RadioBtn} onClick={() => handleStoreSelection(props.store.location.toString())}>
					{selectedStore === props.store.location.toString() ?
						<RadioButtonChecked fontSize="large"/>
						:
						<RadioButtonUnchecked fontSize="large"/>
					}
				</div>
				<div className={classes.StoreTileContent}>
					<StoreLocationTile
						store={props.store}
						showAltChain={props.showAltChain}
						pickupWebsite={props.pickupWebsite}
						handleStoreSelection={handleStoreSelection} />
				</div>
			</div>
		)
	};

	return (
		<div data-test-id="store-locations-main">
			<div className={classes.Title}>
				<p className="body-small bold upper">Select Store</p>
			</div>
			<div className={classes.StoreContainer}>
				<div className={classes.StoreTileContainer}>
					{props.stores.map((store, index) => {
						if (index === 0 && selectedStore === null) {
							setSelectedStore(store.location.toString());
						}
						return (
							<PickupLocation store={store} showAltChain={showAltChain} pickupWebsite={props.pickupWebsite}/>
						)
					})}
				</div>
				<div className={classes.ConfirmBtnContainer}>
					<ThemeProvider theme={buttonTheme}>
						<Button className={classes.ConfirmBtn}
										color="primary"
										variant="contained"
										onClick={() => props.handleConfirm(selectedStore)}>
							<p className="body-large-alt">Confirm Store</p>
						</Button>
					</ThemeProvider>
				</div>
			</div>
		</div>
	);
}
